export default __webpack_public_path__ + "static/Montserrat-Medium-40765136905702b849c90b5211fd314c.woff";